import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

interface Subvenue {
  id: string;
  name: string;
}

interface Venue {
  id: string;
  name: string;
  subvenues: Subvenue[];
}

const GET_ALL_VENUES = gql`
  query getVenues {
    user {
      id
      account {
        id
        venues {
          id
          name
          subvenues {
            id
            name
          }
        }
      }
    }
  }
`;

const GET_VENUES_BY_MEMBERS = gql`
  query getVenuesByMembers($memberIds: [ID!]!) {
    user {
      id
      account {
        id
        venuesByMembers(memberIds: $memberIds) {
          id
          name
          subvenues {
            id
            name
          }
        }
      }
    }
  }
`;

type UseVenuesProps = {
  memberIds?: string[];
};

const useVenues = ({ memberIds }: UseVenuesProps = {}) => {
  const shouldFilterByMembers = memberIds && memberIds.length > 0;

  const { data: allVenuesData } = useQuery(GET_ALL_VENUES, {
    skip: shouldFilterByMembers
  });

  const { data: filteredVenuesData } = useQuery(GET_VENUES_BY_MEMBERS, {
    variables: { memberIds },
    skip: !shouldFilterByMembers
  });

  const venues: Venue[] = shouldFilterByMembers
    ? filteredVenuesData?.user?.account?.venuesByMembers || []
    : allVenuesData?.user?.account?.venues || [];

  return { venues };
};

export default useVenues;
